import Icon, { IconProps } from './Icon';

import AiSparkleIcon from '../../../assets/icons/ai-sparkle.svg?react';

/** Fixed purple gradient glyph - omit `color`/`hoverColor`, they flatten the gradient to a solid fill. */
const AiSparkle: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <AiSparkleIcon />
    </Icon>
  );
};

export default AiSparkle;
